<template>
  <div class="iaSelect" :id="id">
    <span class="label">{{ label }}</span>
    <div class="min-w-[80px] relative">
      <button @click="open = !open"
              class="btn"
      >
        <span class="flex-1 text-left truncate">{{ valueCalculated }}</span>
        <svg :class="{'rotate-90': open}"  width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.75 10.395L5.573 5.57202L0.75 0.750019" stroke="#9C27B0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div v-if="open" class="options">
        <ul class="">
          <li v-for="(option, index) in options" :key="index"
              @click="setOption(option)"
              class="px-[12px] py-[8px] cursor-pointer hover:text-purple border-b border-[#EFEFEF]"
              :class="{'text-purple': option[fieldKey] === optionSelected, 'rounded-[8px]': index === options.length - 1}"
          >{{ option[fieldValue] }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: {
      default: null
    },
    optionSelected: {
      default: null
    },
    options: {
      default: []
    },
    fieldValue: {
      default: 'name'
    },
    fieldKey: {
      default: 'id'
    },
    label: {
      default: null
    }
  },
  data() {
    return {
      open: false,
      id: crypto.randomUUID()
    }
  },
  computed: {
    valueCalculated() {
      if (this.optionSelected && this.options?.length > 0) {
        return this.options.filter(option => option[this.fieldKey] === this.optionSelected)[0][this.fieldValue]
      }
      return this.placeholder
    }
  },
  methods: {
    setOption(option) {
      this.$emit('onSelect', option[this.fieldKey])
      this.open = false
    },
    closeDropdownOnOutsideClick() {
      document.addEventListener('click', (e) => {
        if (document.getElementById(this.id) && !document.getElementById(this.id).contains(e.target)) {
          this.open = false
        }
      })
    }
  },
  mounted() {
    this.closeDropdownOnOutsideClick()
  }
}
</script>
<style lang="scss">
.iaSelect {
  font-size: 12px;
  border-radius: 8px;
  display: flex;
  gap: .05rem;
  height: 40px;
  width: min-content;
  .truncate{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .label {
    display: flex;
    align-items: center;
    color: #26282a;
    height: 100%;
  }
  .btn{
    height: 38px;
    font-size: 12px;
    max-width: 140px;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    min-width: 83px;
    padding: 9px;
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #eaeaec;
  }
  .options {
    position: absolute;
    background-color:#fff;
    width: max-content;
    border-radius: 8px;
    max-width: 200px;
    top: 100%;
    overflow: auto;
    max-height: 200px;
    border: 1px solid #949494;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li{
        padding: 9px 12px;
      }
    }
  }

}
</style>
